import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import authenticateReducer from './loginpages/authenticateReducer';
import userInputsReducer from './loginpages/userInputsReducer';
import tfaReducer from './tfapages/tfaReducer';
import globalReducer from './layout/reducer';
import registrationReducer from './registration/registrationReducer';

const logger = store => next => action => {
    //console.group(action.type)
    //console.info('dispatching', action)
    let result = next(action);
    //console.log('next state', store.getState())
    //console.groupEnd(action.type)
    return result;
};

const middleware = [thunkMiddleware, logger];
const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);

const store = createStoreWithMiddleware(
    combineReducers({
        authenticateReducer,
        userInputsReducer,
        tfaReducer,
        globalReducer,
        registrationReducer,
    }),
    // for Chrome redux devtools
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
